import {
  useEffect,
  React,
  useState,
  icons,
  useSelector,
  faqListApi,
  setFaqData,
  useDispatch,
  startFaqLoading,
  stopFaqLoading,
  Components
} from '../utils/npm'
import { formatDate, formatIndianPrice } from './CommonFunction';

const { Loader } = Components
// const { FaPlus, FaMinus } = icons

const IpoAccordian = ({ ipoDetailData }) => {

  const companyName = ipoDetailData?.company_name?.split(" ").slice(0, 2).join(" ") + " IPO";

  const faqItems = [
    {
      question: `What is the ${companyName} ?`,
      answer: `${companyName} is a main-board IPO of ${formatIndianPrice(ipoDetailData?.fresh_issue_value)} equity shares of the face value of ${formatIndianPrice(ipoDetailData?.face_value)} aggregating up to 
      ₹${formatIndianPrice(ipoDetailData?.offer_of_sale_value)} crore shares. The issue is priced at ${ipoDetailData?.price_range || '.'} per share. The minimum order quantity is .The IPO opens on ${formatDate(ipoDetailData?.start_date)}, and closes on ${formatDate(ipoDetailData?.end_date)}. Link Intime India Private Ltd is the registrar for the IPO. The shares are proposed to be listed on ${ipoDetailData?.listing_at_group}.`
    },
    {
      question: `How to apply in ${companyName} through Zerodha?`,
      answer: `Zerodha customers can apply online in ${companyName} using UPI as a payment gateway. Zerodha customers can apply in ${companyName} by login into Zerodha Console (back office) and submitting an IPO application form. 
      Steps to apply in ${companyName} through Zerodha
        (1) Visit the Zerodha website and login to Console.
        (2) Go to Portfolio and click the IPOs link.
        (3) Go to the '${companyName}' row and click the 'Bid' button.
        (4) Enter your UPI ID, Quantity, and Price.
        (5) Submit IPO application form.
        (6) Visit the UPI App (net banking or BHIM) to approve the mandate.

        Visit Zerodha IPO Application Process Review for more detail.
      `
    },
    {
      question: `When ${companyName} will open?`,
      answer:
        `The ${companyName} opens on ${formatDate(ipoDetailData?.start_date)} and closes on ${formatDate(ipoDetailData?.end_date)}.`
    },
    {
      question:
        `How to apply for ${companyName} ?`,
      answer:
        `You can apply in ${companyName} online using either UPI or ASBA as a payment method. ASBA IPO application is available in the net banking of your bank account. UPI IPO application is offered by brokers who don't offer banking services. Read more detail about applying IPO online through Zerodha, Upstox, 5Paisa, Nuvama, HDFC Bank, and SBI Bank.`
    },
    {
      question: `When is ${companyName} allotment?`,
      answer: `The finalization of Basis of Allotment for ${companyName} will be done on ${formatDate(ipoDetailData?.allotment_date)}, and the allotted shares will be credited to your demat account by ${formatDate(ipoDetailData?.allotment_date)}`
    },
    {
      question: `When is  ${companyName} listing date?`,
      answer: `${companyName}'s listing date is ${formatDate(ipoDetailData?.listing_date)}.`
    },
    {
      question: `What is ${companyName} GMP (Grey Market Premium)?`,
      answer: `${companyName} GMP (Grey Market Premium) is the unofficial price at which IPO shares trade before listing on the stock exchange. It shows investor demand, IPO listing gain expectations, and overall IPO market sentiment.Current GMP is ₹${`${ipoDetailData?.gmp != null ? ipoDetailData?.gmp : ''}`}.`
    }
  ]
  const dispatch = useDispatch()
  const [selectedIndex, setSelectedIndex] = useState(null)
  const { faqData, error, loading } = useSelector(state => state.fagListData)
  const toggleSelected = index => {
    setSelectedIndex(selectedIndex === index ? null : index)
  }

  return loading ? (
    <div className="flex justify-center pt-1 pb-2"><Loader /></div>
  ) : (
    <ul className='shadow-box'>
      {faqItems.map((item, index) => (
        <li
          key={index}
          className='relative border-b border-gray-200 accordian_item'
        >
          <button
            type='button'
            className='w-full py-4 text-left'
            onClick={() => toggleSelected(index)}
          >
            <div className='flex items-center justify-between'>
              <span className='accrodian_title'>{item.question}</span>
              <span className='plusMinus'></span>
              {selectedIndex === index ? (
                <div className='icon minus  cursor-pointer hover:scale-105 transition-all'></div>
              ) : (
                <div className='icon plus  cursor-pointer hover:scale-105 transition-all'></div>
              )}
            </div>
          </button>
          <div
            className={`relative ${selectedIndex === index ? 'overflow-auto' : 'overflow-hidden'
              } transition-all duration-500 ${selectedIndex === index ? 'border-t border-slate-200 pt-5' : ''
              } `}
            style={{
              maxHeight: selectedIndex === index ? '1000px' : '0'
            }}
          >
            <div className='px-6 pb-6'>
              <p className='faq_answer text-sm lg:text-md '>{item.answer}</p>
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default IpoAccordian
